import axios from './Interceptor.js';
let address = window.global_config.BASE_URL2;

let smartSearch = {
  GetPageList: info => {
    return axios({
      method: 'post',
      url: `${address}DataMapping/GetPageList`,
      data: info
    });
  },
  NewQueryParentListBySynchronization: info => {
    return axios({
      method: 'post',
      url: `${address}DataSynchronization/NewQueryParentListBySynchronization`,
      data: info
    });
  },
  GetList: info => {
    return axios({
      method: 'get',
      url: `${address}DataMapping/GetList?Key=`
    });
  }
};

export default smartSearch;
